// extracted by mini-css-extract-plugin
export var fadeIn = "_3s-0";